import { IMAGES } from "@/lib/site";

const FACTS = [
    {
        figure: "65,000+",
        unit: "years",
        body: "of continuous land and sea management — the longest record in human history.",
    },
    {
        figure: "80 / 1",
        unit: "percent",
        body: "Indigenous peoples globally safeguard around 80% of remaining biodiversity, yet receive less than 1% of international climate funding.",
    },
    {
        figure: "57%",
        unit: "of Australia",
        body: "of Australia's lands and waters now sit under formally recognised First Nations interests.",
    },
    {
        figure: "87",
        unit: "IPAs",
        body: "Indigenous Protected Areas covering 90 million hectares of land and 6 million hectares of sea.",
    },
    {
        figure: "1,900 → 3,800",
        unit: "ranger jobs",
        body: "Current ranger workforce across 320 groups — set to double by 2030.",
    },
    {
        figure: "~1.2M",
        unit: "tonnes / year",
        body: "of emissions abated through Indigenous-led savanna fire management across roughly 24 million hectares.",
    },
];

export default function Numbers() {
    return (
        <section
            id="numbers"
            data-testid="numbers-section"
            className="relative py-24 md:py-32 lg:py-40 bg-bone overflow-hidden"
        >
            <div className="absolute inset-0 pointer-events-none opacity-[0.07]">
                <img
                    src={IMAGES.earth}
                    alt=""
                    aria-hidden
                    className="w-full h-full object-cover"
                />
            </div>

            <div className="relative max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16">
                <div className="grid grid-cols-12 gap-6 md:gap-12 mb-14 md:mb-20">
                    <div className="col-span-12 md:col-span-5">
                        <span className="number-mark text-ink2">§ 03 / Scale</span>
                        <h2
                            data-testid="numbers-heading"
                            className="mt-4 font-serif text-4xl md:text-5xl lg:text-6xl leading-[1.02] text-ink"
                        >
                            A sector already
                            <br />
                            <em className="italic font-light text-eucalyptus">
                                delivering.
                            </em>
                        </h2>
                    </div>
                    <div className="col-span-12 md:col-span-7 md:pl-12 flex items-end">
                        <p className="text-ink2 text-lg md:text-xl leading-relaxed max-w-2xl">
                            Caring for Country is not a sector being invented
                            today. It already exists, it is already delivering
                            — and its scale, presence and economic footprint
                            sit far beneath the national conversation it
                            deserves.
                        </p>
                    </div>
                </div>

                <div
                    data-testid="numbers-grid"
                    className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 border-l border-t border-rule"
                >
                    {FACTS.map((f, i) => (
                        <article
                            key={i}
                            data-testid={`number-${i}`}
                            className="border-r border-b border-rule p-8 md:p-10 bg-bone/70 backdrop-blur-[1px]"
                        >
                            <span className="number-mark text-ochre">
                                — {String(i + 1).padStart(2, "0")}
                            </span>
                            <p className="mt-6 font-serif text-4xl md:text-5xl lg:text-[58px] leading-[0.98] text-ink tracking-tight">
                                {f.figure}
                            </p>
                            <p className="mt-2 eyebrow text-eucalyptus">
                                {f.unit}
                            </p>
                            <p className="mt-6 text-ink2 text-[15px] leading-relaxed">
                                {f.body}
                            </p>
                        </article>
                    ))}
                </div>

                <p className="mt-12 text-ink2 italic text-[15px] max-w-3xl">
                    Indicative figures drawn from publicly reported programs,
                    parks data and federal investment commitments. Numbers
                    grow with the work on Country.
                </p>
            </div>
        </section>
    );
}
